import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { HostConfig, HostConfigState } from './types'
import { DataFetchingState } from '@AppState/types'
import { fetchHostAndAppConfig } from '@AppState/app-settings/app-settings-slice'
import { store } from '@AppState/redux-store.ts'

const initialState: HostConfigState = {
  fetchState: DataFetchingState.IDLE,
  config: null,
}

export const fetchMaintenanceHostConfig = createAsyncThunk(
  'fetchMaintenanceHostConfig',
  async () => {
    return await fetchHostConfig()
  },
)

export const fetchHostConfig = async (): Promise<HostConfig> => {
  const appConfig = store.getState().appConfig
  const response = await fetch(appConfig.config!.hostConfig)

  if (!response.ok) {
    const responseBody = await response.text()
    throw new Error(
      `Could not fetch host config at ${appConfig.config?.hostConfig}, got: ${responseBody}`,
    )
  }

  return await response.json()
}

export const hostConfigSlice = createSlice({
  name: 'hostConfig',
  initialState,
  reducers: {
    setHostConfig(state, action: { payload: HostConfig }) {
      state.config = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchHostAndAppConfig.fulfilled, (state, action) => {
      state.fetchState = DataFetchingState.SUCCEEDED
      state.config = action.payload?.hostConfig
    })
    builder.addCase(fetchHostAndAppConfig.pending, (state) => {
      state.fetchState = DataFetchingState.PENDING
      state.config = null
    })
    builder.addCase(fetchHostAndAppConfig.rejected, (state, action) => {
      console.error(action.error)
      state.fetchState = DataFetchingState.FAILED
      state.config = null
    })
    builder.addCase(fetchMaintenanceHostConfig.fulfilled, (state, action) => {
      state.fetchState = DataFetchingState.SUCCEEDED
      state.config = action.payload
    })
    builder.addCase(fetchMaintenanceHostConfig.pending, (state) => {
      state.fetchState = DataFetchingState.PENDING
      state.config = null
    })
    builder.addCase(fetchMaintenanceHostConfig.rejected, (state, action) => {
      console.error(action.error)
      state.fetchState = DataFetchingState.FAILED
      state.config = null
    })
  },
})

export const HostConfigReducer = hostConfigSlice.reducer
